<template>
  <v-card flat class="pb-10">
    <v-container>
      <template>
        <v-card
            color="grey lighten-4"
            width="100%" flat
        >
          <v-card-title class="text-h6 grey lighten-3">
            Review Course Details and Resources
          </v-card-title>

          <div class="py-5 px-2 ma-5">

            <v-row>
              Review the details and resources for this course.
            </v-row>

            <v-row>
              <v-card-subtitle>
                Course Details
              </v-card-subtitle>
            </v-row>

            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-file-edit-outline
                    </v-icon>
                  </v-col>

                  <div v-if="item.name">
                    <v-col class="primary--text text-h5 pt-2">
                      {{ item.name }}
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col>
                      <div class="error--text pt-4 ml-0 pl-0">
                        Course name should be set.
                      </div>
                    </v-col>
                  </div>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-format-line-style
                    </v-icon>
                  </v-col>

                  <v-col
                      v-if="item.description"
                      cols="8"
                      class="text-body-1 text-h5 pt-3">
                    {{ item.description }}
                  </v-col>

                  <v-col v-else>
                    <div class="error--text pt-4">
                      Course Description should be set.
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-currency-gbp
                    </v-icon>
                  </v-col>

                  <div v-if="item.priceInUnits">
                    <v-col class="text-body-1 text-h5 pt-3">
                      {{ (item.priceInUnits / 100).toFixed(2) }}
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col>
                      <div class="error--text pt-4">
                        Course price should be set.
                      </div>
                    </v-col>
                  </div>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-cash
                    </v-icon>
                  </v-col>

                  <div v-if="item.currency">
                    <v-col class="text-body-1 text-h5 pt-3">
                      {{ item.currency }}
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col>
                      <div class="error--text pt-4">
                        Price currency should be set.
                      </div>
                    </v-col>
                  </div>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-heart
                    </v-icon>
                  </v-col>

                  <div v-if="item.popular">
                    <v-col class="text-body-1 text-h5 pt-3">
                      This is a popular course.
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col class="text-body-1 text-h5 pt-3">
                      This is a not a popular course.
                    </v-col>
                  </div>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-numeric
                    </v-icon>
                  </v-col>

                  <div v-if="item.level">
                    <v-col class="text-body-1 text-h5 pt-3">
                      {{ item.level.name }}
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col class="text-body-1 text-h5 pt-3 grey--text">
                      Not applicable
                    </v-col>
                  </div>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-seal-variant
                    </v-icon>
                  </v-col>

                  <div v-if="item.certificationBody">
                    <v-col class="text-body-1 text-h5 pt-3">
                      {{ item.certificationBody.name }}
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col class="text-body-1 text-h5 pt-3 grey--text">
                      Not applicable
                    </v-col>
                  </div>
                </v-row>

                <v-row>
                  <v-col cols="1">
                    <v-icon>
                      mdi-folder-multiple-plus-outline
                    </v-icon>
                  </v-col>

                  <!-- Bug #4450 - Add/Edit course not displaying categories upon review -->
                  <div v-if="item.categories">
                    <v-col class="text-body-1 text-h5 pt-3">
                      <v-chip
                          v-for="category in item.categories"
                          :key="category"
                          class="mr-2"
                      >
                        {{ category.name }}
                      </v-chip>
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col>
                      <div class="error--text pt-4">
                        Course categories should be set.
                      </div>
                    </v-col>
                  </div>
                </v-row>

                <v-row class="mb-5">
                  <v-col cols="1">
                    <v-icon>
                      mdi-tag-multiple-outline
                    </v-icon>
                  </v-col>

                  <div v-if="item.tags" >
                    <v-col class="text-body-1 text-h5 pt-3">
                      <TagsDisplay :items="item.tags"/>
                    </v-col>
                  </div>

                  <div v-else>
                    <v-col>
                      <div class="error--text pt-4">
                        Course tags should be set.
                      </div>
                    </v-col>
                  </div>
                </v-row>
              </v-col>

              <v-col cols="5">
                <v-row class="ml-1">
                  <ReviewImage :image="item.image" />
                </v-row>
              </v-col>
            </v-row>

            <v-divider />

            <v-row class="mt-5">
              <v-card-subtitle>
                Course Resources
              </v-card-subtitle>
            </v-row>

            <v-row>
              <ResourceResultCard :items=item.resources>
                <template v-slot:scorm="slotProps">
                  <ResourceScorm :scorm="slotProps.scorm"
                  />
                </template>
                <template v-slot:video="slotProps">
                  <ResourceVideo :video="slotProps.video" />
                </template>
              </ResourceResultCard>
            </v-row>

            <v-row v-if="courseApiError">
              <v-alert
                  text
                  color="red"
                  icon="mdi-alert-circle-outline"
              >
                There was an error in submission. Please check all fields and try again.
              </v-alert>
            </v-row>
          </div>
        </v-card>
      </template>
    </v-container>
  </v-card>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import ResourceScorm from "@/components/Courses/ResourceScorm";
import ResourceVideo from "@/components/Courses/ResourceVideo";
import ResourceResultCard from "@/components/common/ResourceResultCard";
import TagsDisplay from "@/components/common/TagsDisplay";
import ReviewImage from "@/components/common/ReviewImage";

export default {
  name: "ReviewDetails",
  components: {
    ReviewImage, TagsDisplay, ResourceResultCard, ResourceVideo, ResourceScorm,
  },
  props: {
    item: Object,
  },

  computed: {
    ...mapGetters([
      'courseApiError', 'categories', 'levels', 'certificationBodies', 'courseCurrencies',
    ]),
  },
  methods: {
    ...mapActions([
      'getCategories',
    ]),
  },
};
</script>